import { BaseApi } from "./baseService";
import { Injectable } from "@angular/core";
import { RequestOptions } from "@angular/http";
import { BaseResponse } from "../objects/common/baseResponse";

@Injectable()
export class LogService extends BaseApi {

    public save(logRequest:any): Promise<BaseResponse<any>> {
        return this.post(new RequestOptions({
            url: `log`,
            body: logRequest
        }))
    }
}


// WEBPACK FOOTER //
// ./app/services/logService.ts